<template>
    <div>



        <validation-observer v-slot="vo" slim>
            <b-modal size="xl"
                     centered
                     no-close-on-backdrop
                     no-close-on-esc
                     no-enforce-focus
                     v-model="newRuleData.dialogOpen"
                     v-on:ok.prevent="vo.handleSubmit(newDataRetentionRule)"
                     v-on:cancel="resetNewRuleData()">
                <template #modal-header>
                    <h5 class="modal-title">{{isEdit ? 'Edit' : 'New'}} Rule:</h5>
                </template>
                <template #default>
                    <b-alert :show="(newRuleData.currentErrors != null) && (newRuleData.currentErrors.length > 0)" variant="danger" dismissible>
                        <div v-for="(error, index) in newRuleData.currentErrors" :key="index">
                            <p>{{ error }}</p>
                        </div>
                    </b-alert>


                    <validation-provider :rules="{ required: true, min: 3 }" name="Name" v-slot="vp1">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text>Name:</b-input-group-text>
                            </b-input-group-prepend>
                            <template>
                                <b-form-input placeholder="Rule name/label/description" v-model="customFilterName" maxlength="100"></b-form-input>
                                <b-form-invalid-feedback :state="vp1.errors[0] ? false : null">{{ vp1.errors[0] }}</b-form-invalid-feedback>
                            </template>
                        </b-input-group>
                    </validation-provider>

                    <b-card>
                        <filter-builder ref="filterBuilder" :fields="fields" :filter="currentFilter" @change="filterChanged" :maxGroupCount="0"></filter-builder>
                    </b-card>

                    <validation-provider :rules="{ required: true, min: 3 }" name="Action" v-slot="vp2">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text>Action:</b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="newRuleData.retentionAction" :options="allDataRetentionActions"></b-form-select>
                            <b-form-invalid-feedback :state="vp2.errors[0] ? false : null">{{ vp2.errors[0] }}</b-form-invalid-feedback>
                        </b-input-group>
                    </validation-provider>

                        <b-input-group>
                            <b-form-checkbox v-model="newRuleData.activeStatus">Active</b-form-checkbox>
                        </b-input-group>


                </template>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-secondary" @click="cancel()" :disabled="newRuleData.busy">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="ok()" :disabled="newRuleData.busy || newRuleData.disabled">
                        <b-spinner small v-if="newRuleData.busy" label="Creating new Rule..."></b-spinner>
                        <template v-if="!newRuleData.busy">
                            {{isEdit ? 'Save' : 'Create'}}
                        </template>
                    </button>
                </template>
            </b-modal>


        </validation-observer>









    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import UuidMixins from '../mixins/UuidMixins';

    import FilterBuilder from './FilterBuilder/FilterBuilder';

    Vue.use(BootstrapVue);
    
    Vue.component('filter-builder', FilterBuilder);

    export default {
        name: 'DataRetentionRuleDialog',
        mixins: [ErrorsMixin, DateTimeMixin, UuidMixins],
        model: {
            event: 'change',
            prop: 'filter'
        },
        props: {

            newRuleInitialData: {
                type: Object,
                required: true
            },

            //fields: {
            //    type: Array,
            //    required: false
            //},
            /*
            quickFilters: {
                type: Array,
                default: null
            }, */
            filter: {
                type: Object,
                default: null
            },
            relatedTo: {
                type: String,
                default: null
            },
            apiBaseUrl: {
                String,
                default: null,
                required: false
            },

            allCourtRegistryOptions: {
                type: Array,
                default: null
            },
            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            allOrderStatusOptions: {
                type: Array,
                default: null
            },
            allDataRetentionActions: {
                type: Array,
                default: null
            },
            allAttachmentClassifications: {
                type: Array,
                default: null
            },

        },


        data: function () {
            return {
                quickFilters: null,
                currentQuickFilter: null,

                currentFilterFields: null,
                currentFilter: this.filter,
                previousFilter: null,
                filterPanelOpen: true,
                filterDirty: false,
                filterDisplayText: null,

                customFilterName: null,
                oldCustomFilterName: null,

                newRuleData: {
                    dialogOpen: false,
                    currentErrors: null,
                    busy: false,
                    disabled: false,
                    inputData: null,
                    selectedRow: null,
                    retentionAction: null,
                    activeStatus: false
                },

                fields: [
                    {
                        field: "CourtRegistryId",
                        label: "Court/Tribunal/Other",
                        type: "multiselect",
                        options: this.allCourtRegistryOptions,
                        placeholder: "Select Court/Tribunal/Other Values"
                    },
                    {
                        field: "InterviewOrganisationId",
                        label: "Interview Organisation",
                        type: "multiselect",
                        options: this.allInterviewOrganisationOptions,
                        placeholder: "Select Interview Organisation Values"
                    },
                    //{
                    //    field: "SittingDate",
                    //    label: "Sitting Date",
                    //    type: "timespan",
                    //    format: "dMy"
                    //},
                    {
                        field: "Confirmed",
                        label: "Confirmed",
                        type: "boolean"
                    },
                    {
                        field: "ConfirmedDateTimeUTC",
                        label: "Confirmed Date",
                        type: "timespan",
                        format: "dMy"

                    },
                    {
                        field: "CompletedDateTimeUTC",
                        label: "Date Delivered",
                        type: "timespan",
                        format: "dMy"
                    },
                    //{
                    //    field: "ServiceTypeId",
                    //    label: "Service Type",
                    //    type: "multiselect",
                    //    options: this.allServiceTypeOptions,
                    //    placeholder: "Select Service Types"
                    //},
                    //{
                    //    field: "ServiceDelayId",
                    //    label: "Turnaround",
                    //    type: "multiselect",
                    //    options: this.allServiceDelayOptions,
                    //    placeholder: "Select Turnaround Values"
                    //},
                    //{
                    //    field: "Status",
                    //    label: "Status",
                    //    type: "multiselect",
                    //    options: this.allOrderStatusOptions,
                    //    placeholder: "Select Status Values"
                    //},
                    //{
                    //    field: "Restricted",
                    //    label: "Restricted Mode",
                    //    type: "boolean",
                    //    options: [{ value: false, text: "Not Restricted" }, { value: true, text: "Restricted" }]
                    //},
                    {
                        field: "AttachmentClassification",
                        label: "Attachment Type",
                        type: "multiselect",
                        options: this.allAttachmentClassifications
                    },
                    //{
                    //    field: "Test",
                    //    label: "Test",
                    //    type: "timespan",
                    //    format: "dMy"
                    //}
                ],



            }
        },
        watch: {
            //fields: function () {
            //    this.createCurrentFilterFields();
            //},
            filter: function () {
                this.currentQuickFilter = null;
                this.currentFilter = this.filter;
                if (this.$refs.filterBuilder) this.filterDisplayText = this.$refs.filterBuilder.filterDisplayText;
            },
            newRuleDataOpen: function () {
                this.customFilterName = null;
                if (this.newRuleDataOpen) {
                    this.newRuleData = this.newRuleInitialData;


                    this.currentFilter = this.isEdit ? this.newRuleData.selectedRow.filter : null;
                    if (this.isEdit) {
                        this.customFilterName = this.newRuleData.selectedRow.name;
                        this.newRuleData.retentionAction = this.newRuleData.selectedRow.action.stringValue;
                        this.newRuleData.activeStatus = this.newRuleData.selectedRow.active;

                    }
                }

                else
                    this.newRuleData = {
                        dialogOpen: false,
                        currentErrors: null,
                        busy: false,
                        disabled: false,
                        inputData: null,
                        selectedRow: null,
                        retentionAction: null,
                        activeStatus: true
                    };
            }

        },
        computed: {
            filterStatus: function () {
                if (this.filterDisplayText) return this.filterDisplayText;
                return "Inactive";
            },
            newRuleDataOpen: function () {
                if (this.newRuleInitialData != null) return this.newRuleInitialData.dialogOpen;
                return false;
            },
            isEdit: function () {
                return (this.newRuleInitialData.selectedRow != null);
            }


        },
        methods: {
            resetNewRuleData: function () {
                this.newRuleData.dialogOpen = false;
            },
            
            filterChanged: function (filter) {
                this.currentFilter = filter;
                this.filterDirty = true;
            },
            applyQuickFilter: function (quickFilter) {

                // applying custom filter name to text input field
                this.customFilterName = (quickFilter.shared || quickFilter.default) ? null : quickFilter.name;
                this.currentQuickFilter = quickFilter;
                var filterString = JSON.stringify(quickFilter.filter);
                this.currentFilter = JSON.parse(filterString, (key, value) => {
                    if (value && (typeof value === 'string')) {
                        var today = this.formatDateTime(this.now(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${today}/gi, today);
                        var thisWeekStart = this.formatDateTime(this.weekStart(), 'DD/MM/YYYY', false, false);
                        var thisWeekEnd = this.formatDateTime(this.weekEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thisweekstart}/gi, thisWeekStart);
                        value = value.replace(/\${thisweekend}/gi, thisWeekEnd);
                        var lastWeekStart = this.formatDateTime(this.weekStart(-1), 'DD/MM/YYYY', false, false);
                        var lastWeekEnd = this.formatDateTime(this.weekEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastweekstart}/gi, lastWeekStart);
                        value = value.replace(/\${lastweekend}/gi, lastWeekEnd);
                        var thisMonthStart = this.formatDateTime(this.monthStart(), 'DD/MM/YYYY', false, false);
                        var thisMonthEnd = this.formatDateTime(this.monthEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thismonthstart}/gi, thisMonthStart);
                        value = value.replace(/\${thismonthend}/gi, thisMonthEnd);
                        var lastMonthStart = this.formatDateTime(this.monthStart(-1), 'DD/MM/YYYY', false, false);
                        var lastMonthEnd = this.formatDateTime(this.monthEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastmonthstart}/gi, lastMonthStart);
                        value = value.replace(/\${lastmonthend}/gi, lastMonthEnd);
                        var thisQuarterStart = this.formatDateTime(this.quarterStart(), 'DD/MM/YYYY', false, false);
                        var thisQuarterEnd = this.formatDateTime(this.quarterEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thisquarterstart}/gi, thisQuarterStart);
                        value = value.replace(/\${thisquarterend}/gi, thisQuarterEnd);
                        var lastQuarterStart = this.formatDateTime(this.quarterStart(-1), 'DD/MM/YYYY', false, false);
                        var lastQuarterEnd = this.formatDateTime(this.quarterEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastquarterstart}/gi, lastQuarterStart);
                        value = value.replace(/\${lastquarterend}/gi, lastQuarterEnd);
                        var thisYearStart = this.formatDateTime(this.yearStart(), 'DD/MM/YYYY', false, false);
                        var thisYearEnd = this.formatDateTime(this.yearEnd(), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${thisyearstart}/gi, thisYearStart);
                        value = value.replace(/\${thisyearend}/gi, thisYearEnd);
                        var lastYearStart = this.formatDateTime(this.yearStart(-1), 'DD/MM/YYYY', false, false);
                        var lastYearEnd = this.formatDateTime(this.yearEnd(-1), 'DD/MM/YYYY', false, false);
                        value = value.replace(/\${lastyearstart}/gi, lastYearStart);
                        value = value.replace(/\${lastyearend}/gi, lastYearEnd);

                        return value;
                    }
                    console.log('value = ' + value);
                    return value;
                });

                this.filterDisplayText = this.createFilterDisplayText(this.currentFilter);
                this.filterDirty = false;
                this.filterPanelOpen = false;
                this.$emit('change', this.currentFilter);

            },
            newDataRetentionRule: function () {
                this.newRuleData.busy = true;
                var url = this.$urlHelper.getApiUrl('DataRetention', this.isEdit ? 'edit' : 'create');
                var readableRule = this.$refs.filterBuilder.filterDisplayText;
                var ruleId = this.isEdit ? this.newRuleData.selectedRow.id : null;
                var action = this.newRuleData ? this.newRuleData.retentionAction : "Delete";

                if (this.currentFilter == null) {
                    this.newRuleData.currentErrors = ["Rule requires at least one condition."];
                    this.newRuleData.busy = false;
                    return;
                }

                var data =
                {
                    name: this.customFilterName,
                    description: readableRule,
                    filter: this.currentFilter,
                    id: ruleId,
                    action: {
                        enumValue: action
                    },
                    active:this.newRuleData.activeStatus
                };

                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.resetNewRuleData();
                        this.newRuleData.busy = false;
                        this.newRuleData.disabled = false;

                        this.$bvToast.toast(this.isEdit ? 'Rule updated successfully' : 'New Rule created successfully', {
                            title: this.isEdit ? 'Rule Updated' : 'Rule Created',
                            variant: 'success',
                            appendToast: true
                        });

                        //this.grid.refresh();
                        this.newRuleData.dialogOpen = false;
                    })
                    .catch(ex => {
                        this.newRuleData.currentErrors = this.handleAxiosException(ex);
                        this.newRuleData.busy = false;
                    });
            },


        },
        mounted: function () {
            
        }
    }
</script>
<style scoped>
    .e-rule-field {
        display: flex;
        align-items: center;
    }

    .e-template-value {
        flex-grow: 1;
    }

        .e-template-value .e-multiselect {
            max-width: none !important;
        }

        .e-template-value .e-multi-select-wrapper {
            max-width: none !important;
        }
</style>